/* eslint-disable prefer-destructuring */
import {
  ANDROID_SHOP,
  APPLE_SHOP,
  HUAWEI_SHOP,
  MAX_SUPPORT,
  MAX_SUPPORT_PURCAHSE,
  SECRET_KEY_ADMIN,
  TG_SUPPORT,
  TG_SUPPORT_PURCAHSE,
  VK_SUPPORT,
} from '../constant/constants';
import { AlertSeverityEnum } from '../enum/AlertSeverityEnum';
import { IAlertProps } from '../interface/IAlertProps';
import { IApiResult } from '../interface/IApiResult';

export const HandleVkSupport = (isPurchase: string) => {
  if (isPurchase !== '') {
    window.open(VK_SUPPORT);
  } else {
    window.open(VK_SUPPORT);
  }
};

export const HandleTelegramSupport = (isPurchase: string) => {
  if (isPurchase !== '') {
    window.open(`${TG_SUPPORT_PURCAHSE}${isPurchase}`);
  } else {
    window.open(TG_SUPPORT);
  }
};

export const HandleMaxSupport = (isPurchase: string) => {
  if (isPurchase !== '') {
    window.open(`${MAX_SUPPORT_PURCAHSE}${isPurchase}`);
  } else {
    window.open(MAX_SUPPORT);
  }
};

export const HandleAutoShopView = (device: number) => {
  if (device === 0) {
    window.open(APPLE_SHOP);
  }
  if (device === 1) {
    window.open(ANDROID_SHOP);
  }
  if (device === 2) {
    window.open(HUAWEI_SHOP);
  }
};

export const HandleView = (url: string) => {
  window.open(url);
};

export const generateUserIdMemmory = () =>
  `auto_${Math.random().toString(36).substr(2, 9)}${Date.now().toString(36)}`;

// Генерация уникального ID
export const generateUserId = () =>
  `shop_${Math.random().toString(36).substr(2, 9)}${Date.now().toString(36)}`;

export const getOrCreateUserId = () => {
  let userId = localStorage.getItem('anonymousUserId');
  if (!userId) {
    userId = generateUserId();
    localStorage.setItem('anonymousUserId', userId);
  }
  return userId;
};

export const isMobileView = () => {
  const result = window.innerWidth < 820;
  return result;
};

export const getDefaultAlertProps = () => {
  const alertApp: IAlertProps = {
    message: '',
    severity: AlertSeverityEnum.error,
  };
  return alertApp;
};

export const getDefaultApiResult = () => {
  const apiResult: IApiResult = {
    isSuccess: false,
    status: -1,
    data: null,
    alert: getDefaultAlertProps(),
  };
  return apiResult;
};

export const setToken = (tokenType: string) =>
  `${localStorage.getItem(tokenType)}`;

export const secureToken = () => {
  const expires = Math.floor(Date.now() / 1000) + 10;
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const md5 = require('md5');
  const crc = md5(`${SECRET_KEY_ADMIN}${expires}`);
  const url = `expires=${expires}&crc=${crc}`;
  return url;
};

export const gteMd5 = (id: string) => {
  const timestamp = Math.floor(Date.now() / 1000);
  const toMd5 = `${timestamp}nurlat${id}`;
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const md5 = require('md5');
  const crc = `${timestamp}${md5(toMd5)}`;
  return crc;
};

export const gteMd5Conspect = (id: string) => {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const md5 = require('md5');
  const crc = `${md5(id)}`;
  return crc;
};

export const getCookie = (name: string) => {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(
        /([\\.$?*|{}\\(\\)\\[\]\\\\/\\+^])/g,
        '\\$1'
      )}=([^;]*)`
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};
